module.exports = __webpack_public_path__ + "img/card-product1.82f955f8.jpg";